import React from 'react';
import cx from 'classnames';
import { DateTime } from 'luxon';
import { Link } from 'react-router-dom';
import { MdAssignment, MdModeEdit } from 'react-icons/md';
import { DropDown } from '~/components';
import { stringUtils } from '~/util';
import {PolicySearchRequestStatus} from "~/pages/PolicySearchRequest/common";
import {isTryonBot} from "~/util/auth";

export const DateCell = (fieldName) => ({data}) => {
    const value = data[fieldName];

    if (!value)
        return (<></>);

    const parsed = DateTime.fromISO(value);

    return (
        `${parsed.toLocaleString()}`
    );
};

export const AddressCell = ({data, ...rest}) => {
    const {
        streetNumber,
        streetName,
        streetSuffix
    } = data;

    return (
        <span {...rest}>
            {streetNumber} {streetName} {streetSuffix}
        </span>
    );
};

export const NameCell = ({data, ...rest}) => {
    const value = `${data.ownerFirstName} ${data.ownerLastName}`;

    return (
        <span {...rest}>
            {value}
        </span>
    );
};

export const statusLabels = {
    [1]: 'New Request',
    [2]: 'In Progress',
    [3]: 'Found',
    [4]: 'Not Found',
    [5]: 'Review'
};

const StatusPill = ({statusId, fallback}) => {
    let label;
    if (statusLabels[statusId] != undefined) {
        label = statusLabels[statusId];
    } else {
        label = fallback;
    }

    const classes = cx(
        'rounded-full',
        'py-1', 'px-2',
        'text-xs', 'leading-3',
        'border',
        {
            ['bg-warning-10 text-warning-60 border-warning-30']: statusId == 1,
            ['bg-primary-10 text-primary-60 border-primary-30']: statusId == 2,
            ['bg-success-10 text-success-60 border-succcess-30']: statusId == 3,
            ['bg-error-10 text-error-60 border-error-30']: statusId == 4,
            ['bg-gray-100']: statusId > 4
        }
    );

    return <span className={classes}>{label}</span>;
};

export const StatusCell = ({data, ...rest}) => (
    <span {...rest}>
        <StatusPill statusId={data.statusId} fallback={data.status}/>
    </span>
);

export const ActionMenu = () => ({data, ...rest}) => {
    
    const isModifiedByBot = data.statusId === PolicySearchRequestStatus.Review || isTryonBot(data?.modifiedBy?.roleId);
    return (
        <span {...rest}>
            <DropDown
                wrapperClass="rounded-md border bg-white text-neutral-80 text-sm z-20 filter drop-shadow-xl left-0 top-full mt-1"
                iconClass="text-white"
                iconSize='1.25em'
                buttonClass="p-1 bg-gray-10 text-white focus:outline-none hover:bg-secondary-30 rounded-full flex items-center justify-center"
                text=''>
                <section className="flex flex-col items-stretch w-48 text-gray-80">
                    <p className="font-semibold text-sm p-4 py-2">Action</p>
                    <Link to={`/policySearch/${data.id}?viewOnly=true`} className="py-2 px-4 hover:bg-blue-10 flex items-center">
                        <MdAssignment />
                        <span className="ml-2">View</span>
                    </Link>
                    {isModifiedByBot && !data.completed && (
                        <Link to={`/policySearch/${data.id}`} className="py-2 px-4 hover:bg-blue-10 flex items-center">
                            <MdModeEdit />
                            <span className="ml-2">Update</span>
                        </Link>)}
                </section>
            </DropDown>
        </span>
    );
};

export function CompletedBy({data, ...rest}) {
    const value = `${data.modifiedBy.firstName} ${data.modifiedBy.lastName}`;

    return [3, 4, 5].includes(data.statusId)
        ? <span {...rest}>{value}</span>
        : <></>;
}

export function LockedBy({data, ...rest}) {
    const value = `${data.modifiedBy.firstName} ${data.modifiedBy.lastName}`;

    return [2].includes(data.statusId)
        ? <span {...rest}>{value}</span>
        : <></>;
}

export const FirmName = (firms = []) => ({data, ...rest}) => {
    const { firmId } = data;
    const firm = firms.find(f => f.Id == firmId);

    if (firm) {
        return (
            <span {...rest}>
                {stringUtils.truncate(firm.Name)}
            </span>
        );
    }
    return <></>;
};